import StringColumn from '@isceco/widget-library2/basic-elements/List/column/StringColumn.js'

export default class VNBColumns {

  static getColumns() {
    return [
      VNBColumns.NAME_COLUMN(),
      VNBColumns.ADRESSE_COLUMN(),
      VNBColumns.OSTRAL_VERANTWORTLICHER_COLUMN()
    ]
  }

  static NAME_COLUMN() {
    return new StringColumn({
      key: 'name',
      text: 'vnb.table.header.name',
      sortable: true
    })
  }

  static ADRESSE_COLUMN() {
    return new StringColumn({
      key: 'adresse',
      text: 'vnb.table.header.adresse',
      sortable: true
    })
  }

  static OSTRAL_VERANTWORTLICHER_COLUMN() {
    return new StringColumn({
      key: 'ostralVerantwortlicher',
      text: 'vnb.table.header.ostralVerantwortlicher',
      sortable: true
    })
  }
}
